module.exports = __webpack_public_path__ + "img/teaser-screen.f4d4b94e.png";